const env = process.env.REACT_APP_ENV
const redirectAfterLogin = encodeURIComponent(window.location.href)

const envConfig = {
  dev: {
    LOGIN_URL: `https://test-lmit-srmlocker-itlm-ping-47rh53ma5a-ew.a.run.app/sso/auth/?sso&redirectAfterLogin=${redirectAfterLogin}`,
    API_URL: 'http://localhost:5000',
  },
  test: {
    LOGIN_URL: `https://test-lmit-regtva-itlm-ping-gwkygibq6a-ew.a.run.app/sso/auth/?sso&redirectAfterLogin=${redirectAfterLogin}`,
    API_URL: 'https://test-reg-tva-backend-gwkygibq6a-ew.a.run.app',
  },
  prod: {
    LOGIN_URL: `https://prod-lmit-regtva-itlm-ping-gwkygibq6a-ew.a.run.app/sso/auth/?sso&redirectAfterLogin=${redirectAfterLogin}`,
    API_URL: 'https://prod-reg-tva-backend-gwkygibq6a-ew.a.run.app',
  },
}

export default envConfig[env]
